import { render } from "./stacked-bar-chart.vue?vue&type=template&id=336a8f67&lang=pug"
import script from "./stacked-bar-chart.vue?vue&type=script&lang=js"
export * from "./stacked-bar-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__